import { h, render, Component } from 'preact';
import { Text} from 'preact-i18n';
import Markup from 'preact-markup';
import debounce from 'lodash.debounce';
import axios from 'axios';
import AePolicy from './AePolicy';
import { GetSearchEndPoint, GetSafeImageUrl } from '../utils/ApiUtil';
import HtmlToText from 'html-to-text';
import { WidgetHelper } from '../widgets/utils/widgetHelper';
import {EscapeQuery, UnescapeQuery } from '../utils/ApiUtil';
import WidgetLoader from './WidgetLoader';

class SearchInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            baseQuery: "",
            query: "",
            webSuggestions: [],
            suggestOn: false,
            isSafeSearchOn: false,
            activeSelection: -1,
            showLocationWidget: false,
            currentLocationName: "",
            currentCountryCode: "",
            currentLocation: "",
            lang: "",
            isThemeDropdownOpen: false,
            isSafeSearchDropdownOpen: false
        }
        this.loadedWidgets = {};

        this.getSuggestionsDebounced = debounce(this.getSuggestions.bind(this), 250);
        this.inputRef = null;
        this.registeredEvent = false;

        this.themeOptions = [{name: 'system', translationId: "newSearch.systemTheme"},
                                {name: 'light', translationId: "newSearch.lightTheme"},
                                {name: 'dark', translationId: "newSearch.darkTheme"}
                              ]

        this.safeSearchOptions = [{name: "none", translationId: "newSearch.none"},
                                    {name: "moderate", translationId: "newSearch.moderate"},
                                    {name: "strict", translationId: "newSearch.strict"}
                                  ]
    }
    componentDidMount() {
      const parameters = new URLSearchParams(window.location.search);
      let query = parameters.get('q');
      if(query) {
        query = UnescapeQuery(query);
      }
      this.setState(c => {
        c.isSafeSearchOn = this.props.isSafeSearchOn === true ? this.props.isSafeSearchOn : false;
        c.query = query ? HtmlToText.htmlToText(query) : "";
        c.baseQuery = c.query;
        c.currentLocationName = this.props.currentLocationName ? this.props.currentLocationName : "";
        c.currentLocation = this.props.currentLocation ? this.props.currentLocation : "";
        c.currentCountryCode = this.props.currentCountryCode ? this.props.currentCountryCode : "";
        c.lang = this.props.lang ? this.props.lang : "";
        return c;
      });
      this.handleBackButton();
      setTimeout(() => {
        this.registerEvents();
      }, 100);
      this.registerForLocation();
    }
    componentWillUpdate(newProps) {
      if((this.state.isSafeSearchOn === true && newProps.isSafeSearchOn === false) ||
         (this.state.isSafeSearchOn === false && newProps.isSafeSearchOn === true)) {
        this.setState(c => {
          c.isSafeSearchOn = newProps.isSafeSearchOn;
          return c;
        })
      }
      if(newProps.currentLocationName !== this.state.currentLocationName ||
         newProps.currentLocation !== this.state.currentLocation ||
         newProps.currentCountryCode !== this.state.currentCountryCode ||
         newProps.lang !== this.state.lang) {
        this.setState(c => {
          c.currentLocationName = newProps.currentLocationName;
          c.currentLocation = newProps.currentLocation;
          c.currentCountryCode = newProps.currentCountryCode;
          c.lang = newProps.lang;
          return c;
        })
      }
    }
    registerForLocation() {
      if(this.props.showLocationWidget) {
        WidgetHelper.RegisterForLocationUpdate(() => {
          this.setState(c => {
            c.showLocationWidget = false;
            return c;
          });
        })
      }
    }
    clearQuery(evt) {
      evt.stopPropagation();
      this.setState(c => {
        c.query = "";
        c.webSuggestions = [];
        c.suggestOn = false;
        return c;;
      }, () => {
        this.inputRef.focus();
      })
    }
    hasQuery() {
      const parameters = new URLSearchParams(window.location.search);
      const query = parameters.get('q');  
      if(query) {
        return true;
      }
      return false;
    }
    isLanding() {
      const pageUrl = new URL(window.location.href);
      const pathname = pageUrl.pathname;
      if(pathname == "/") {
        return true;
      }
      return false;
    }
    setInputRef(dom) {
        this.inputRef = dom;
    }
    handleBackButton() {
      window.addEventListener('popstate', () => {
        const parameters = new URLSearchParams(window.location.search);
        const query = parameters.get('q');    
        if(this.state.query != query) {
          this.setState(c => {
            c.query = query;
            c.webSuggestions = [];
            return c;
          })    
        }
      })
    }
    registerEvents() {
        if(this.inputRef && !this.registeredEvent) {
          this.registeredEvent = true;
          this.inputRef.addEventListener("click", (e) => {
            if(this.inputRef.focus) {
              this.inputRef.focus();
            }
            e.preventDefault();
            e.stopPropagation();
            this.setState(c => {
              c.suggestOn = true;
              return c;
            });
          });
          document.addEventListener("click", () => {
            this.setState(c => {
              c.suggestOn = false;
              c.showLocationWidget = false;
              c.isSafeSearchDropdownOpen = false;
              c.isThemeDropdownOpen = false;
              return c;
            });
          });
          document.addEventListener("keydown", (e) => {
            if(e.key === "Escape") {
              this.setState(c => {
                c.showLocationWidget = false;
                c.isSafeSearchDropdownOpen = false;
                c.isThemeDropdownOpen = false;
                return c;
              })
            }
          });

          this.inputRef.addEventListener("keydown", (e) => {
            if(e.keyCode != 13 && (!this.state.webSuggestions || this.state.webSuggestions.length === 0)) {
              //no point doing anything
              return;
            }
            if(e.keyCode !== 40 && e.keyCode !== 38 && e.keyCode !== 13) {
              if(e.key === "Escape") {
                this.setState(c => {
                  c.suggestOn = false;
                  c.activeSelection = -1;
                  return c;
                });
              } else {
                this.setState(c=> {
                  c.activeSelection = -1;
                  return c;
                });
              }
            } else {
              this.setState(c => {
                let activeSelection = c.activeSelection;
                if (e.keyCode == 40) {
                  activeSelection += 1;
                  e.preventDefault();
                } else if (e.keyCode == 38) { //up
                  activeSelection -= 1;
                  e.preventDefault();
                }
                if(e.keyCode === 40 || e.keyCode === 38) {
                  let count = this.state.webSuggestions ? this.state.webSuggestions.length : 0;
                  if(activeSelection < 0) {
                    activeSelection += count;
                  }
                  if(activeSelection >= count) {
                    activeSelection -= count;
                  }
                  if(this.state.webSuggestions[activeSelection].searchKind === "link") {
                    c.query = c.baseQuery;                     
                  } else {
                    c.query = this.state.webSuggestions[activeSelection].query; 
                  }
                  c.suggestion = this.state.webSuggestions[activeSelection];
                  c.suggestOn = true;
                  c.activeSelection = activeSelection;
                }
                return c;
              });
              if (e.keyCode == 13) {
                e.preventDefault();
                this.onSubmit();
              }
            }
          });
        }    
    }
    handleSuggestMouseEnter(evt, ix) {
      this.setState(c=> {
        c.activeSelection = ix;
        return c;
      });
    }
    onSubmit(evt) {
        if(evt) {
          evt.preventDefault();
        }
        if (document.activeElement) {
          document.activeElement.blur();
        }
        let suggestion = {...this.state.suggestion};
        this.setState(c => {
          c.webSuggestions = [];
          c.suggestOn = false;
          c.suggestion = null;
          return c;
        }, () => {
          if(suggestion && suggestion.searchKind === "link") {
            window.open(suggestion.url, '_blank');
          } else if(this.state.query) {
            this.props.onSubmit(this.state.query)
          } else if(this.inputRef?.value) {
            this.props.onSubmit(this.inputRef?.value)
          }
        });
    }
    onInput(evt) {
        const { value } = evt.target;
        this.setState(c => {c.query = value; c.baseQuery = value; c.suggestOn = true; c.activeSelection=-1;return c;})
        this.getSuggestionsDebounced(value);
    }
    getSuggestions(value) {
        this.registerEvents();
        let sugUrl = `${GetSearchEndPoint()}?q=${encodeURIComponent(value)}&service=suggestions&safesearch=${this.state.isSafeSearchOn}`;
        if(this.state.currentCountryCode) {
          sugUrl += "&country=" + this.state.currentCountryCode;
        }
        if(this.state.lang) {
          sugUrl += "&lang=" + this.state.lang;
        }
        if(this.state.currentLocation) {
          sugUrl += "&latlon=" + this.state.currentLocation;
        }
        if(this.props.affid) {
          sugUrl += "&affid=" + this.props.affid;
        }
        let pos = this.props.pos ? this.props.pos : "serp";
        sugUrl += `&pos=${pos}-searchinput`;

        axios.get(sugUrl)
        .then((response) => {
            let resp = response.data;
            let webSuggestions = [];
            if(resp) {
              if(resp.suggestionGroups && resp.suggestionGroups.length > 0) {
                for(let ix in resp.suggestionGroups) {
                    let suggGrp = resp.suggestionGroups[ix];
                    if(suggGrp.name === "Web") {
                    webSuggestions = [...suggGrp.searchSuggestions];
                    break;
                    }
                }
              }

              // insert affiliate search suggestions into the websuggestions
              if(resp.AffSearchInfo && resp.AffSearchInfo.sources) {
                for(let ix in resp.AffSearchInfo.sources) {
                  let source = resp.AffSearchInfo.sources[ix];
                  if(source.count && source.count > 0 && source.items) {
                    for(let it in source.items) {
                      let affsug = source.items[it];
                      let newsug = {
                        url: affsug.deeplinkuri,
                        displayText: affsug.title,
                        query: affsug.snippet,
                        imageuri: affsug.imageuri,
                        searchKind: "link"
                      }
                      let done = false;
                      webSuggestions.forEach((ws, ctr) => {
                        if(!done && ws.searchKind != "link" && (affsug.suggestion === ws.query || affsug.suggestion === value)) {
                          webSuggestions.splice(ctr, 0, newsug);
                          done = true;
                        }
                      })
                      if(!done) {
                        webSuggestions.push(newsug);
                      }
                    }
                  }
                }  
              }

              // insert affiliate search suggestions into the websuggestions
              if(resp.QuickLinkInfo && resp.QuickLinkInfo.length > 0) {
                //pick only first two
                let cnt =0;
                for(let ix in resp.QuickLinkInfo) {
                  let affsug = resp.QuickLinkInfo[ix];
                  if(!affsug.domain) {
                    continue;
                  }
                  let newsug = {
                    url: affsug.url,
                    displayText: affsug.domain,
                    query: `https://${affsug.domain}`,
                    imageuri: affsug.imageuri,
                    searchKind: "link"
                  }
                  let qcheck = affsug.domain.split(".")[0];
                  let inix = -1;
                  let hasDomain = false;
                  webSuggestions.map((ws, ix) => {
                    if(inix === -1 && ws.searchKind !== 'link' && ws.query >= qcheck) {
                      inix = ix;
                    }
                    if(!hasDomain && ws.searchKind === 'link' && ws.query.indexOf(affsug.domain) > -1) {
                      hasDomain = true;
                    }
                  });
                  if(hasDomain) {
                    continue;
                  }
                  cnt++;
                  if(cnt > 2) {
                    break;
                  }

                  inix = inix > -1 ? inix : (webSuggestions.length - 1);
                  webSuggestions.splice(inix, 0, newsug);
                }
              }

            }
            this.setState(c => {
              c.webSuggestions = webSuggestions;
              return c;
            })
        }, (error) => {})
    }
    locationChangeClick(evt) {
      if(evt) {
        evt.stopPropagation();
      }
      this.setState(c => {
        c.showLocationWidget = !c.showLocationWidget;
        // close theme and safesearch dropdowns
        if (c.showLocationWidget) {
          c.isSafeSearchDropdownOpen = false;
          c.isThemeDropdownOpen = false;
        }
        return c
      });
    }
    handleQueryClick(sug) {
      if(sug) {
        if(sug.searchKind === "link") {
          this.setState(c=> {
            c.query = c.baseQuery;
            c.suggestion = sug;
            return c;
          }, this.onSubmit.bind(this))      
        } else {
          this.setState(c=> {
            c.suggestion = sug;
            c.query = sug.query;
            return c;
          }, this.onSubmit.bind(this))      
        }
      }
    }
    trimLength(txt) {
      if(!txt) {
        return txt;
      }
      if(txt.length > 35) {
        txt = txt.substr(0, 32) + "...";
      }
      return txt;
    }
    renderSuggestions() {
        if(this.state.suggestOn && this.state.webSuggestions.length > 0) {
            return (
            <div className="ae-para-large auto-suggest-list">
                <div className="auto-suggest-divider" />
                {this.state.webSuggestions.map((sug, ix) => {
                let clsName = "auto-suggest-item";
                if(ix === this.state.activeSelection) {
                    clsName = "auto-suggest-item active";
                }
                return (
                    <div 
                      className={clsName} 
                      onClick={()=> {this.handleQueryClick(sug)}}
                      onMouseEnter={(evt) => this.handleSuggestMouseEnter(evt, ix)}
                      onMouseDown={(evt)=> evt.preventDefault()}
                    >
                      <div className="search-button-div">
                        <span height="18px" width="18px">
                          {sug.searchKind === "link" ?
                            (<img src={GetSafeImageUrl(sug.imageuri)} style={{width: "18px", height: "18px"}}/>)
                            : (<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 18 18" width="18px" fill="#DDD">
                              <path d="M0 0h24v24H0V0z" fill="none"/>
                              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                            </svg>)
                          }              
                        </span>
                      </div>
                      {sug.searchKind === "link" ? (
                        <div className="link-suggest">
                          <Markup className="link-suggest-text" markup={this.trimLength(sug.displayText)} type="html" trim={false}/>
                          &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;
                          <Markup className="link-suggest-url" markup={this.trimLength(sug.query)} type="html" trim={false}/>
                        </div>
                      ) : (
                        <Markup markup={sug.displayText} type="html" trim={false}/>
                      )}
                    </div>
                )
                })}
            </div>
            )
        }
    }
    getThemeTranslationId() {
      let translationId = "";
      this.themeOptions.map((theme) => {
        if (this.props.themeMode === theme.name) {
          translationId = theme.translationId;
        }
      })
      return translationId;
    }
    toggleThemeDropdown(evt) {
      if(evt) {
        evt.stopPropagation();
      }
      this.setState(c => {
        c.isThemeDropdownOpen = !c.isThemeDropdownOpen;
        // close location and theme dropdowns
        if (c.isThemeDropdownOpen) {
          c.showLocationWidget = false;
          c.isSafeSearchDropdownOpen = false;
        }
        return c;
      })
      
    }
    
    renderThemeDropdown() {
      return (
        <div className={this.props.isRightToLeft ? "ae-border-box dropdown-wrapper rtl" : "ae-border-box dropdown-wrapper"} style={this.state.isThemeDropdownOpen ? "display: block" : "display: none"}>
          <div className='dropdown-content'>
            <div className="dropdown-header">
              <span className="ae-subtitle headerInfo"><Text id="newSearch.Appearance">Appearance</Text></span>
              <span className="closeIcon" onClick={() => this.setState({isThemeDropdownOpen: false})}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="var(--black)">
                  <path d="M0 0h24v24H0V0z" fill="none"/>
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
                </svg>
              </span>
            </div>
            {this.themeOptions.map((theme) => {
              return (
                <div className="dropdown-item ae-para" onClick={this.props.setTheme.bind(this,theme.name)}>
                  <input id="safe-search-checkbox" type="radio" checked={this.props.themeMode === theme.name}></input>
                  <span><Text id={theme.translationId}>{theme.name}</Text></span>  
                </div>
              )}
            )}
          </div>
        </div>
      )
    }
    getSafeSearchTranslationId() {
      let translationId = "";
      this.safeSearchOptions.map((safeSearch) => {
        if (this.props.safeSearchLevel === safeSearch.name) {
          translationId = safeSearch.translationId;
        }
      })
      return translationId;
    }
    toggleSafeSearchDropdown(evt) {
      if(evt) {
        evt.stopPropagation();
      }
      this.setState(c => {
        c.isSafeSearchDropdownOpen = !c.isSafeSearchDropdownOpen;
        // close location and safesearch dropdowns
        if (c.isSafeSearchDropdownOpen) {
          c.showLocationWidget = false;
          c.isThemeDropdownOpen = false;
        }
        return c;
      })
    }
    renderSafeSearchDropdown() {
      return (
        <div className={this.props.isRightToLeft ? "ae-border-box dropdown-wrapper rtl" : "ae-border-box dropdown-wrapper"} style={this.state.isSafeSearchDropdownOpen ? "display: block" : "display: none"}>
          <div className='dropdown-content'>
            <div className="dropdown-header">
              <span className="ae-subtitle headerInfo"><Text id="newSearch.safeSearch">SafeSearch</Text></span>
              <span className="closeIcon" onClick={() => this.setState({isSafeSearchDropdownOpen: false})}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="var(--black)">
                  <path d="M0 0h24v24H0V0z" fill="none"/>
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
                </svg>
              </span>
            </div>
            {this.safeSearchOptions.map((safeSearch) => {
              return (
                <div className="dropdown-item ae-para" onClick={this.props.setSafeSearch.bind(this,safeSearch.name)}>
                  <input id="safe-search-checkbox" type="radio" checked={this.props.safeSearchLevel === safeSearch.name}></input>
                  <span><Text id={safeSearch.translationId}>{safeSearch.name}</Text></span>  
                </div>
              )}
            )}
          </div>
        </div>
      )
    }
    renderLocationDropdown() {
      return (
        <div className="ae-browse-live ae-border-box locationWidgetWrapper" style={{display: (this.state.showLocationWidget ? "block" : "none")}}>
          <div className='dropdown-content'>
            <div className="dropdown-header">
              <span className="ae-subtitle headerInfo"><Text id="newSearch.wantDifferentLocation">Want results for a different location?</Text></span>
              <span className="closeIcon" onClick={() => this.setState({showLocationWidget: false})}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="var(--black)">
                  <path d="M0 0h24v24H0V0z" fill="none"/>
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
                </svg>
              </span>
            </div>
            <div id="locationWidget">
              <WidgetLoader name="location" />          
            </div>
          </div>
        </div>
      )
    }
    render() {
      let inputWrapperCls  = "ui action input inputwrapper";
      if(this.state.suggestOn && this.state.webSuggestions.length > 0) {
        inputWrapperCls  = "ui action input inputwrapper with-suggestions";
      }
      let inputCls = "searchInput";
      if(!this.state.suggestOn) {
        inputCls = "searchInput without-suggestion"
      }
      return (
        <div className="ae-search-input">
          <form  onSubmit={this.onSubmit.bind(this)} className="ui form">
            <div className={inputWrapperCls}>
              <div className="subInputwrapper ae-input">
                <div className="search-button-div" style={{display: this.state.suggestOn ? "flex": "none"}}>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 18 18" width="18px" fill="#DDD">
                      <path d="M0 0h24v24H0V0z" fill="none"/>
                      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                    </svg>              
                  </span>
                </div>
                <input 
                  className={inputCls} 
                  id="searchInputId"
                  ref={this.setInputRef.bind(this)} 
                  key="searchInputId"
                  type="text" 
                  autocomplete="off"
                  enterkeyhint="search"
                  placeholder={this.props.safeSearchPlaceholder ? this.props.safeSearchPlaceholder  : "Safe, anonymous, and ad-free search"}
                  value={this.state.query} onInput={this.onInput.bind(this)}></input>
                <div className="clear-query" style={{display: (this.state.query && !this.props.hideInputImg) ? "flex": "none" }} onClick={this.clearQuery.bind(this)}>
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="var(--black)">
                    <path d="M0 0h24v24H0V0z" fill="none"/>
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
                  </svg>                  
                </div>
                <div className="search-icon-btn" onClick={() => this.onSubmit()}>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 18 18" width="18px" fill="#DDD">
                      <path d="M0 0h24v24H0V0z" fill="none"/>
                      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                    </svg>              
                  </span>
                </div>
              </div>
              {this.renderSuggestions()}
            </div>
            <div className="ae-caption inputRow">
              {this.hasQuery() ? ("") : (
                <div className="no-q-ms-privacy">
                  <div className="ms-results">
                    <Text id="newSearch.bingShopResult">Search results from Microsoft Bing and our shopping partners</Text>&nbsp;
                    { this.isLanding() ?
                      ( <span className="results-policy">
                          <a className="result-count" href='https://go.microsoft.com/fwlink/?LinkId=521839' target='_blank'><Text id="newSearch.microsoftPolicy">Microsoft Privacy</Text></a>
                          <AePolicy  service={this.state.service}/>
                        </span>
                      ) : ("")
                    }
                    
                  </div>
                  { this.isLanding() ? ("") : <AePolicy {...this.props} /> }
                </div>
              )}
              <div className="priv-loc-switch">
                {(this.hasQuery() || this.isLanding()) ? ("") : (
                  <span style={{marginRight: "5px", textDecoration: "underline"}}><a href='https://go.microsoft.com/fwlink/?LinkId=521839' target='_blank'><Text id="newSearch.microsoftPolicy">Microsoft Privacy</Text></a></span>
                )} 
                {this.props.showLocationWidget ? (
                  <div className="locationChangeSwitch" onClick={(evt)=> evt.stopPropagation()}>
                    <div className="search-safe-switch dropdown-label" onClick={this.locationChangeClick.bind(this)} style={this.state.showLocationWidget ? "color: var(--blue)" : ""}>
                      <div>
                        <svg alt="screen mode" height="15px" width="15px" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-dot" class="svg-inline--fa fa-location-dot fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                          {/*<Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.>*/}
                          <path fill={"currentColor"} d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"/>
                        </svg>
                      </div>
                      <div>
                        <div className="search-safe-text">{this.state.currentLocationName ? this.state.currentLocationName : <Text id="newSearch.setLocation">Set location</Text>}</div>
                      </div>
                    </div>
                    {this.renderLocationDropdown()}
                  </div>
                ):("")}
                <div className="locationChangeSwitch" onClick={(evt)=> evt.stopPropagation()}>
                  <div className="search-safe-switch dropdown-label" onClick={this.toggleSafeSearchDropdown.bind(this)} style={this.state.isSafeSearchDropdownOpen ? "color: var(--blue)" : ""}>
                    <div>
                      <svg alt="screen mode" height="15px" width="15px" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="shield-halved" class="svg-inline--fa fa-shield-halved fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">{/*<Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.>*/}
                        <path fill={"currentColor"} d="M256-.0078C260.7-.0081 265.2 1.008 269.4 2.913L457.7 82.79C479.7 92.12 496.2 113.8 496 139.1C495.5 239.2 454.7 420.7 282.4 503.2C265.7 511.1 246.3 511.1 229.6 503.2C57.25 420.7 16.49 239.2 15.1 139.1C15.87 113.8 32.32 92.12 54.3 82.79L242.7 2.913C246.8 1.008 251.4-.0081 256-.0078V-.0078zM256 444.8C393.1 378 431.1 230.1 432 141.4L256 66.77L256 444.8z"/>
                      </svg>
                    </div>
                    <div>
                      <div className="search-safe-text"><Text id={this.getSafeSearchTranslationId()}>{this.props.safeSearchLevel}</Text></div>
                    </div>
                  </div>
                  {this.renderSafeSearchDropdown()}
                </div>
                <div className="locationChangeSwitch" onClick={(evt)=> evt.stopPropagation()}>
                  <div className="search-safe-switch dropdown-label" onClick={this.toggleThemeDropdown.bind(this)} style={this.state.isThemeDropdownOpen ? "color: var(--blue)" : ""}>
                    <div>
                      <svg alt="screen mode" height="15px" width="15px" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="window-restore" class="svg-inline--fa fa-window-restore fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        {/*<Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.>*/}
                        <path fill={"currentColor"} d="M432 64H208C199.2 64 192 71.16 192 80V96H128V80C128 35.82 163.8 0 208 0H432C476.2 0 512 35.82 512 80V304C512 348.2 476.2 384 432 384H416V320H432C440.8 320 448 312.8 448 304V80C448 71.16 440.8 64 432 64zM0 192C0 156.7 28.65 128 64 128H320C355.3 128 384 156.7 384 192V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V192zM96 256H288C305.7 256 320 241.7 320 224C320 206.3 305.7 192 288 192H96C78.33 192 64 206.3 64 224C64 241.7 78.33 256 96 256z"/>
                      </svg>
                    </div>
                    <div>
                      <div className="search-safe-text"><Text id={this.getThemeTranslationId()}>{this.props.themeMode}</Text></div>
                    </div>
                  </div>
                  {this.renderThemeDropdown()}
                </div>
              </div>
            </div>
          </form>
        </div>
      );
    }  
}
export default SearchInput;
